import { Component, OnInit, Injector, OnDestroy, ViewChild } from '@angular/core';
import { forkJoin, Subscription } from 'rxjs';

// components
import { BuyerComponent } from './buyer.component';
import { FullListComponent } from '../../shared/components/full-list/full-list.component';

// models
import { Buyer } from '../../shared/models/buyer';
import { User } from '../../shared/models/user';

// services
import { BuyerService } from '../../shared/services/buyer.service';
import { LanguageService } from '../../shared/services/language.service';

import { UserService } from '../shared/services/user.service';

@Component({
  selector: 'buyers-component',
  templateUrl: 'buyers.component.html',
  styleUrls: ['./buyers.component.scss']
})
export class BuyersComponent extends FullListComponent<Buyer, BuyerComponent> implements OnInit, OnDestroy {

  @ViewChild('confirmation') confirmation: any;
  @ViewChild('details') detailsComponent: BuyerComponent;

  users: Array<User> = [];
  buyerToDisable: Buyer;
  rtlEnabled = localStorage.getItem('last-selected-language-direction') ? JSON.parse(localStorage.getItem('last-selected-language-direction')) : false;
  private _subscription: Subscription;

  constructor(
    protected injector: Injector,
    private buyerService: BuyerService,
    private userService: UserService,
    private languageService: LanguageService
  ) {
    super(injector, Buyer);
    this._subscription = this.languageService.direction.subscribe(dir => {
      this.rtlEnabled = dir;
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this._subscription.unsubscribe();
  }

  ngOnInit() {
    this.title.set('SHARED.BUYER_MANAGEMENT');
    this.setTranslations('BUYER');
    this.getData();
  }

  getData() {
    this.spinner.show();

    forkJoin(
      this.buyerService.getBuyers(),
      this.userService.getUsers()
    ).subscribe(result => {
      this.items = result[0];
      this.items.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });

      this.users = result[1];
      this.spinner.hide();
    }, error => {
      this.errorService.show(error);
      this.spinner.hide();
    });
  }

  edit = (e: any) => {
    const buyerId = e.row !== undefined ? e.row.data.buyerId : e.data.buyerId;
    this.detailsComponent.modalTitle = this.translations.EDIT;
    this.detailsComponent.open(this.items, buyerId, this.users);
  }

  add() {
    this.detailsComponent.modalTitle = this.translations.ADD_NEW;
    this.detailsComponent.open(this.items, null, this.users);
  }

  deleteSelected() {
    this.spinner.show();
    this.buyerService.delete(this.itemIdToDelete).subscribe((buyers) => {
      this.getData();
      this.spinner.hide();
    });

    this.confirmation.opened = false;
  }

  enableDisableBuyer = (e: any) => {
    const buyer: Buyer = e.row.data;
    this.buyerToDisable = buyer;
    this.buyerService.enableDisable(this.buyerToDisable).subscribe(() => {
      this.getData();
    },
      error => {
        this.errorService.show(error);
      }
    );
  }

  navigateToUsers = (e: any) => {
    this.router.navigate(['/platform/users'], { queryParams: { buyers: e.row.data.buyerId } });
  }

  calculateDisabledDisplayValue = (e: any) => {
    if (e.row.data.isActive) {
      return true;
    } else {
      return false;
    }
  }

  calculateEnabledDisplayValue = (e: any) => {
    if (!e.row.data.isActive) {
      return true;
    } else {
      return false;
    }
  }

  deleteItem = (e: any) => {
    this.itemIdToDelete = e.row.data.buyerId;
    this.confirmation.opened = true;
  }
}
